import { useEffect, useState } from 'react';
import { Auth } from '../../config/configuration/react';

export const useRecordRow = ({ purchaseOrder, displayOnlyWinnersInfo, hideMerchantInfo }) => {
  const hideMerchantInfoForUser = Auth.isAllowedToSeeMerchant();
  const [blur, setBluring] = useState(true);
  useEffect(() => {
    if (!purchaseOrder) {
      setBluring(true);
    } else if (hideMerchantInfoForUser) {
      setBluring(true);
    } else if ((hideMerchantInfo && displayOnlyWinnersInfo) || !hideMerchantInfo) setBluring(false);
    else setBluring(true);
  }, [purchaseOrder, displayOnlyWinnersInfo, hideMerchantInfo, hideMerchantInfoForUser]);
  return {
    blur,
  };
};
